import React, { useState } from 'react';
import './ReprocessDialog.css';

const ReprocessDialog = ({ isOpen, onClose, onReprocess, isProcessing = false }) => {
  const [additionalContext, setAdditionalContext] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (additionalContext.trim() && onReprocess) {
      onReprocess(additionalContext.trim());
    }
  };

  const handleClose = () => {
    setAdditionalContext('');
    onClose();
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      handleSubmit(e);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="reprocess-dialog-overlay">
      <div className="reprocess-dialog">
        <div className="reprocess-dialog-header">
          <h3>Reprocessar Pedido</h3>
          <button 
            className="close-btn"
            onClick={handleClose}
            title="Fechar"
            disabled={isProcessing}
          >
            ✕
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="reprocess-dialog-content">
          <div className="reprocess-info">
            <div className="info-icon">🔄</div>
            <div className="info-text">
              <h4>Adicionar Contexto Adicional</h4>
              <p>
                Forneça informações adicionais que podem ajudar a IA a interpretar melhor o pedido.
                Por exemplo: especificações técnicas, preferências do cliente, ou correções.
              </p>
            </div>
          </div>
          
          <div className="context-input-section">
            <label htmlFor="additional-context">
              Contexto Adicional:
            </label>
            <textarea
              id="additional-context"
              value={additionalContext}
              onChange={(e) => setAdditionalContext(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="Digite informações adicionais que podem ajudar na interpretação do pedido..."
              rows={6}
              className="context-textarea"
              disabled={isProcessing}
              required
            />
            <div className="input-help">
              <small>Pressione Ctrl+Enter para reprocessar</small>
            </div>
          </div>
          
          <div className="reprocess-examples">
            <h5>Exemplos de contexto útil:</h5>
            <ul>
              <li>"Cliente prefere produtos da marca X"</li>
              <li>"Correção: quantidade do item 3 deve ser 100, não 10"</li>
              <li>"Adicionar especificação: produtos devem ser resistentes à água"</li>
              <li>"Cliente solicitou urgência na entrega"</li>
            </ul>
          </div>
        </form>
        
        <div className="reprocess-dialog-footer">
          <div className="reprocess-warning">
            <small>
              ⚠️ O reprocessamento irá recriar todos os itens extraídos. 
              As seleções atuais serão perdidas.
            </small>
          </div>
          <div className="reprocess-actions">
            <button 
              type="button"
              className="btn btn-secondary"
              onClick={handleClose}
              disabled={isProcessing}
            >
              Cancelar
            </button>
            <button 
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={isProcessing || !additionalContext.trim()}
            >
              {isProcessing ? (
                <>
                  <div className="spinner"></div>
                  Reprocessando...
                </>
              ) : (
                'Reprocessar Pedido'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReprocessDialog;
